import React, { FC, useEffect } from "react";
import { Switch } from "../../common/Switch";
import { useChangeMarketingNotificationMutation } from "../../../store/services/user";
import { toastError } from "../../../utils/toasts";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../store/reducers/user";

export const NotificationsForm: FC = () => {
  const { marketing_data } = useSelector(selectCurrentUser);

  const [
    changeMarketingNotification,
    { isSuccess, isLoading, isError, error },
  ] = useChangeMarketingNotificationMutation();

  const marketingOnChange = async (value: boolean) =>
    await changeMarketingNotification({
      ...marketing_data,
      notifications_enabled: value,
    });

  useEffect(() => {
    if (isError) {
      toastError("Something was wrong. Try again later");
    }
  }, [isLoading, isSuccess, isError, error]);

  return (
    <div className="flex flex-col gap-8 py-4">
      <div className="pb-6 uppercase text-sm font-manrope font-semibold text-gray-300 tracking-[1px] border-b border-gray-50">
        Notifications
      </div>

      <Switch
        id="NotificationFormUpdates"
        checked={true}
        onChange={() => {}}
        disabled={true}
        className="flex-row-reverse w-full justify-between"
      >
        Invoices, clients and payment updates
      </Switch>

      <Switch
        id="NotificationFormMarketing"
        checked={marketing_data?.notifications_enabled}
        onChange={() =>
          marketingOnChange(!marketing_data?.notifications_enabled)
        }
        disabled={false}
        className="flex-row-reverse w-full justify-between"
      >
        Marketing news and updates
      </Switch>
    </div>
  );
};
